<template>
  <div class="read-only account-read-only">
    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Account Name
      </label>
      <span>{{ account.name }}</span>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Website
      </label>
      <a
        v-if="account.website"
        href="account.website"
      >
        {{ account.website }}
      </a>
      <span v-else>
        ---
      </span>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Account Type
      </label>
      <span>{{ account.account_type.name }}</span>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Parent Account
      </label>
      <router-link
        v-if="account.parent"
        :to="{ name: 'accounts.view', params: { accountId: account.parent.id } }"
      >
        {{ account.parent.name }}
      </router-link>
      <span v-else>
        ---
      </span>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Sub Accounts
      </label>
      <div
        class="tag-input"
        v-if="account.children.length > 0"
      >
        <div class="tag-input__list">
          <router-link
            v-for="acc in account.children"
            :key="acc.id"
            class="tag-input__list__item link"
            :to="`/accounts/${acc.id}`"
          >
            <span>{{ acc.name }}</span>
          </router-link>
        </div>
      </div>
      <span v-else>
        ---
      </span>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        MIFID II
      </label>
      <span
        :class="`${account.is_mifid ? 'text-success' : 'text-danger'}`"
      >
        {{ account.is_mifid ? 'Compliant' : 'Not Compliant' }}
      </span>
    </div>

    <div class="read-only__item">
      <label class="text-black">
        Logo
      </label>

      <img
        v-if="account.logo_url"
        class="d-block"
        :src="account.logo_url"
        :alt="account.name"
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    account: {
      type: Object,
      required: true,
    },
  },
}
</script>

